import { Component } from '@angular/core';
import { BreadcrumbsService } from '../services/breadcrumbs.service';
import { Breadcrumb } from './Breadcrumb';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component( {
  selector: 'app-breadcrumbs-journal',
  templateUrl: './breadcrumbs-journal.component.html',
  styles: [
    ':host { display: block; }'
  ]
} )
export class BreadcrumbsJournalComponent {
  public bc: Array<Breadcrumb>;

  constructor(
    router: Router,
    breadcrumbsSvc: BreadcrumbsService
  ) {
    this.bc = breadcrumbsSvc.BreadcrumbsJournal;
    router.events.pipe(
      filter( e => e instanceof NavigationEnd )
    ).subscribe( () => { this.bc = breadcrumbsSvc.BreadcrumbsJournal; } );
  }
}
